import request from '../js/request'
//情报详情
export function infoDetails(data) {
  return request({
    url: '/shareIntelligence.do',
    method: 'post',
    data: data
  })
}
//情报点赞  interestedShareIntelligence.do  情报点赞
// token  innerId情报ID
export function infoSnap(data) {//已完成
  return request({
    url: '/interestedShareIntelligence.do',
    method: 'post',
    data: data
  })
}
//情报评论点赞
export function infoContentSnap(data) {//已完成
  return request({
    url: '/likeShareIntelligenceComment.do',
    method: 'post',
    data: data
  })
}
//发情报评论
export function infoComment(data) {//已完成
  return request({
    url: '/sharenewsource_comment_add.do',
    method: 'post',
    data: data
  })
}
//情报评论 回复
export function infoCommentReply(data) { //已完成
  return request({
    url: '/sharenewsource_comment_second.do',
    method: 'post',
    data: data
  })
}
//情报评论删除   参数 token  innerId（情报评论ID）
export function infoContentDel(data) {
  console.log('ada',data)
  return request({
    url: '/deleteShareIntelligenceComment.do',
    method: 'post',
    data: data
  })
}
//新闻点赞
export function newsSnap(data) {//已完成
  return request({
    url: '/sharenews_praise.do',
    method: 'post',
    data: data
  })
}
//新闻评论点赞
export function newsContentSnap(data) {//已完成
  return request({
    url: '/sharenewscomment_praise.do',
    method: 'post',
    data: data
  })
}
//新闻评论点赞  取消
export function newsContentSnapCancle(data) {//已完成
  return request({
    url: '/sharenewscomment_praise_cancle.do',
    method: 'post',
    data: data
  })
}
//新闻添加评论  sharenews_comment_add_lev1.do 添加新闻评论
// token newsid新闻ID content评论内容  reply_typereply_type:1表示提问记者，0表示直接回复  to_userid被评论人id
export function newsAddComment(data) {//已完成
  return request({
    url: '/sharenews_comment_add_lev1.do',
    method: 'post',
    data: data
  })
}

// /sharenews_comment_add_lev2.do 新闻评论回复
//token newsid新闻ID  comment_id评论id  content回复内容
export function newsCommentReply(data) {//已完成
  return request({
    url: '/sharenews_comment_add_lev2.do',
    method: 'post',
    data: data
  })
}
//新闻评论删除 sharenewscomment_opt.do   token   comment_id评论id
export function newsCommentDel(data) {
  return request({
    url: '/sharenewscomment_opt.do',
    method: 'post',
    data: data
  })
}
//删除情报
export function delInfo(data) {
  return request({
    // url: '/myIntelligenceInfo.do',
    method: 'post',
    data: data
  })
}
//普通新闻详情
export function newsDetails(data) {
  return request({
    url: '/getsharedcommonnewsdetailinfo.do',
    method: 'post',
    data: data
  })
}
// 视频分享详情
export function videoDetails(data) {
  return request({
    url: '/getsharedvideodetail.do',
    method: 'post',
    data: data
  })
}

// 视频详情点赞状态
//    "token":"F64BEAC7D5B3C44CE3DC0A32DB99FCF0",
//     "newsid":"1257314"
export function praiseFlag(data) {
  return request({
    url: '/praiseFlag.do',
    method: 'post',
    data: data
  })
}
//视频直播详情
export function liveDetails(data) {
  return request({
    url: '/getsharedvideolivedetail.do',
    method: 'post',
    data: data
  })
}
//新闻  评论列表
export function newsCommentList(data) {
  return request({
    url: '/sharenewscomment.do',
    method: 'post',
    data: data
  })
}
//专题新闻详情
export function thematicDetails(data) {
  return request({
    url: '/getsharedsubjectdetailnews.do',
    method: 'post',
    data: data
  })
}
//首页  channelId  1  pageNo 1  pageSize 20  cityId  135
export function index(data) {
  return request({
    url: '/shareMainPage.do',
    method: 'post',
    data: data
  })
}
//图集新闻分享页  "token":"F64BEAC7D5B3C44CE3DC0A32DB99FCF0",  "newsid":1257025
export function atlasDetails(data) {
  return request({
    url: '/shareimgnews_content.do',
    method: 'post',
    data: data
  })
}
//token   openId unionId accessToken
export function getToken(data) {
  return request({
    url: '/shareIdentify.do',
    method: 'post',
    data: data
  })
}
// 获取access_token   code
export function getAccessToken(data) {
  return request({
    url: '/getAccessToken.do',
    method: 'post',
    data: data
  })
}
// 获取微信签名
export function shareUrl(data) {
  return request({
    // url: '/getSignature.do',
    url: '/get_page_config.do',
    method: 'post',
    data: data
  })
}
// 获取code
export function getCode(data) {
  return request({
    url: '/jfshop/selectusercode.do',
    method: 'post',
    data: data
  })
}
// 获取用户信息
export function getUserInfo(data) {
  return request({
    url: '/user_info.do',
    method: 'post',
    data: data
  })
}
// 提交code
export function submit(data) {
  return request({
    url: '/jfshop/addregcode.do',
    method: 'post',
    data: data
  })
}

// 活动外链接口
export function getActUrl(data) {
  return request({
    url: '/active_info.do',
    method: 'post',
    data: data
  })
}

// 直播主播厅
export function liveMain(data) {
  return request({
    url: '/getshareanchorhall.do',
    method: 'post',
    data: data
  })
}
// 报料 上传图片
export function upLoadImg(data) {
  return request({
    url: '/getshareanchorhall.do',
    method: 'post',
    data: data
  })
}
// 报料 发情报
export function sendInfo(data) {
  return request({
    url: '/addShareIntelligence.do',
    method: 'post',
    data: data
  })
}
// 壹点号  主页 上部
export function ydTop(data) {
  return request({
    url: '/getsubchannelbase.do',
    method: 'post',
    data: data
  })
}
// 壹点号  主页 列表
export function ydIndex(data) {
  return request({
    url: '/shareSubChannelNews.do',
    method: 'post',
    data: data
  })
}
//晚报网首页
// 轮播图
export function wbBanner(data) {
  return request({
    url: '/getnewbannerlist.do',
    method: 'post',
    data: data
  })
}
// 频道列表
export function wbChannel(data) {
  return request({
    url: '/qlwbChannelList.do',
    method: 'post',
    data: data
  })
}
// 频道新闻列表
export function channelNews (data) {
  return request({
    url: '/shareSubChannelNews.do',
    method: 'post',
    data: data
  })
}
// 排行榜列表
export function hotList (data) {
  return request({
    url: '/getNewsRankInfoList.do',
    method: 'post',
    data: data
  })
}

// 排行数字
export function hotNum (data) {
  return request({
    url: '/getNewsRankNoByNewsId.do',
    method: 'post',
    data: data
  })
}
// 星星视频
export function starNewsList (data) {
  return request({
    url: '/getAnchorVideoDetailInfo.do',
    method: 'post',
    data: data
  })
}
//智库详情接口
export function thinkTankDetails (data) {
  return request({
    url: '/getThinkReprotInfo.do',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/common/api/api.js